export default "__VITE_ASSET__3bc66f5e__"